"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/styles");
var _mdiMaterialUi = require("mdi-material-ui");
var _UserPicker = _interopRequireDefault(require("./UserPicker.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// ASSETS

var UserListItemIcon = function UserListItemIcon(_ref) {
  var _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    _ref$hovered = _ref.hovered,
    hovered = _ref$hovered === void 0 ? false : _ref$hovered;
  // HOOKS
  var theme = (0, _styles.useTheme)();
  var classes = (0, _UserPicker.default)();

  // STYLES
  var cssCircleButton = (0, _classnames.default)(classes.circleButton, {
    selected: selected,
    remove: selected && hovered
  });
  return /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    color: "inherit",
    "aria-label": "Select user",
    className: cssCircleButton
  }, selected && hovered && /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.Close, {
    fontSize: "small",
    htmlColor: theme.palette.RED400
  }), selected && !hovered && /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.Check, {
    fontSize: "small",
    htmlColor: theme.palette.GREEN400
  }), !selected && /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.Plus, {
    fontSize: "small",
    htmlColor: theme.palette.NEUTRAL500
  }));
};
var _default = UserListItemIcon;
exports.default = _default;